{{#> elements/_dt}}
  {{> elements/_label}}
{{/elements/_dt}}
{{#if options}}
  {{#each options}}
    <dd>
      <input type="{{../type}}" name="{{../prefix}}[{{../name}}][]" {{#if ../testIdPrefix}}data-testid="{{../testIdPrefix}}-{{dasherize ../name}}"{{/if}} id="{{../id}}_{{parameterize this}}" value="{{this}}">
      <label for="{{../id}}_{{parameterize this}}">{{this}}</label>
    </dd>
  {{/each}}
{{else}}
  <dd>
    {{> elements/_input value=1}}
  </dd>
{{/if}}
